module.exports = __webpack_public_path__ + "img/img.4964c0d4.svg";